import { render } from "./AdminGames.vue?vue&type=template&id=01e60022&scoped=true&lang=pug"
import script from "./AdminGames.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminGames.vue?vue&type=script&setup=true&lang=js"

import "./AdminGames.vue?vue&type=style&index=0&id=01e60022&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e60022"]])

export default __exports__